// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAddressAndCardList } from '@tcp/core/src/components/features/account/Payment/container/Payment.actions';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import accountConstants from '@tcp/core/src/components/features/account/Account/Account.constants';
import {
  isPlccUser,
  getMyPlaceNumber,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import AddressBookReducer from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.reducer';
import AddressBookSaga from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.saga';
import CouponReducer from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.reducer';
import CouponSaga from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.saga';
import AccountOverviewNew from '../views/AccountOverviewNew';
import getLinks, { getIsChatBotDisabled } from './AccountOverview.selectors';
import { setTrackOrderModalMountedState } from '../../TrackOrder/container/TrackOrder.actions';
import { getCouponList } from '../../../CnC/common/organism/CouponAndPromos/container/Coupon.actions';
import { setClickAnalyticsData, trackClick } from '../../../../../analytics/actions';
import {
  getPageNameFromState,
  getIsBIAEnabled,
  getIsAccountPageRAR,
  isPlacePerkEnabled,
  getIsNewPegaDigitalChatEnabled,
  getIsGuestFavAppEnabled,
  getPlccOfferPercentage,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getPLCCDiscountValue } from '../../../../common/organisms/Promotions/container/Promotions.selectors';

const AccountOverviewContainer = ({
  fetchCoupons,
  getCardListAction,
  isUserLoggedIn,
  componentBottonLink,
}) => {
  useEffect(() => {
    if (isUserLoggedIn) {
      fetchCoupons();
      getCardListAction();
    }
  }, [isUserLoggedIn]);

  return (
    <AccountOverviewNew
      isPlacePerkEnabled={isPlacePerkEnabled}
      accountNumber={getMyPlaceNumber}
      componentBottonLink={componentBottonLink}
    />
  );
};

AccountOverviewContainer.propTypes = {
  labels: PropTypes.shape({
    accountOverview: PropTypes.shape({}),
  }),
  isUserLoggedIn: PropTypes.bool,
  globalLabels: PropTypes.shape({}),
};

AccountOverviewContainer.defaultProps = {
  labels: {
    accountOverview: {},
  },
  globalLabels: {},
  isUserLoggedIn: false,
};

export const mapStateToProps = (state) => {
  return {
    accountFooterLinks: getLinks(state, accountConstants.FOOTER_LINKS),
    legalLinks: getLinks(state, accountConstants.LEGAL_LINKS),
    disableChatBotABTest: getIsChatBotDisabled(state),
    loyaltyPageName: getPageNameFromState(state),
    isBIAEnabled: getIsBIAEnabled(state),
    isPLCCUser: isPlccUser(state),
    isAccountRAREnabled: getIsAccountPageRAR(state),
    accountNumber: getMyPlaceNumber(state),
    isPlacePerkEnabled: isPlacePerkEnabled(state),
    isNewPegaDigitalChatEnabled: getIsNewPegaDigitalChatEnabled(state),
    isGuestFavAppEnabled: getIsGuestFavAppEnabled(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    openTrackOrder: (payload) => {
      dispatch(setTrackOrderModalMountedState(payload));
    },
    openApplyNowModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    fetchCoupons: () => {
      dispatch(getCouponList());
    },
    getCardListAction: () => {
      dispatch(getAddressAndCardList());
    },
    trackClickAction: (data) => {
      dispatch(trackClick(data));
    },
    setClickAnalyticsDataAction: (data) => {
      dispatch(setClickAnalyticsData(data));
    },
    trackAnalyticsClick: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));

      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 200);
    },
  };
};

const withReducer = withDynamicReducer([
  { key: 'AddressBookReducer', reducer: AddressBookReducer },
  { key: 'CouponsAndPromos', reducer: CouponReducer },
]);
const withSaga = withDynamicSaga([
  { key: 'addressBookSaga', saga: AddressBookSaga },
  { key: 'CouponSaga', saga: CouponSaga },
]);
export default compose(
  withReducer,
  withSaga,
  connect(mapStateToProps, mapDispatchToProps)
)(AccountOverviewContainer);

export { AccountOverviewContainer as AccountOverviewContainerVanilla };
